import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {useImperativeHandle } from 'react';
import {
    isEmpty, CellType, setglobaldata, getglobaldata, isEnabled, Getstorage, DeepCopy, Savestorage, Removestorage,
    getcookie, RandomKey, NumConv, toStringDate, replaceall, DicVal, removeDuplicates, stickycolor, stickymark
} from '../modules/appLibrary';

//---------------------------------------------------------------------
//  AG grid Library
//
//  gridApi
//  gridColumnApi
//  gridid:rowid取得用
//  storekey:storedataキー
//  stickykey:stickykeyキー
//---------------------------------------------------------------------
export default function AGFunction(props, ref) {
    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const [gridApi,setgridApi] = useState(props.gridApi);
    const [gridColumnApi, setgridColumnApi] = useState(props.gridApi);
    const [gridid, setgridid] = useState(props.gridid);
    const CELLTYPE = CellType();

    useImperativeHandle(ref, () => ({
        gridApi() {
            return gridApi;
        },
        gridColumnApi() {
            return gridColumnApi;
        },
        setApi(grid, column, id) {
            setgridApi(grid);
            setgridColumnApi(column);
            setgridid(id);
        },

        //現在の行データをすべて取得
        GetDatasource(api) {
            let grid = isEmpty(api) ? gridApi : api;
            let datasource = [];
            if (!isEmpty(grid)) {
                grid.forEachNode(function (node) {
                    datasource.push(node.data);
                });
            }
            return datasource;
        },
        //表示データのみ取得
        GetAfterFilterData(api) {
            let grid = isEmpty(api) ? gridApi : api;
            let datasource = [];
            grid.forEachNodeAfterFilterAndSort(function (node) {
                datasource.push(node.data);
            });
            return datasource;
        },
        //表示Nodeのみ取得
        GetAfterFilterNode() {
            let datasource = [];
            gridApi.forEachNodeAfterFilterAndSort(function (node) {
                datasource.push(node);
            });
            return datasource;
        },
        //選択行データを取得
        GetSelectrowdata(api) {
            let grid = isEmpty(api) ? gridApi : api;
            let data = [];
            grid.forEachNode(function (node) {
                if (node.isSelected())
                    data.push(node.data);
            });
            return data;
        },
        //選択セルが含まれている行データを取得
        GetRangeSelectrowdata(ranges) {
            let min = ranges[0].startRow.rowIndex > ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
            let max = ranges[0].startRow.rowIndex < ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
            let src = this.GetAfterFilterData();
            let data = [];
            for (let r = min; r <= max; r++) {
                data.push(src[r]);
            }
            return data;
        },
        //選択セルが含まれている行nodeを取得
        GetRangeSelectrownode(ranges) {
            let data = [];
            if (ranges.length === 0) return data;
            let min = ranges[0].startRow.rowIndex > ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
            let max = ranges[0].startRow.rowIndex < ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
            let src = this.GetAfterFilterNode();
            for (let r = min; r <= max; r++) {
                data.push(src[r]);
            }
            return data;
        },
        // datasource Store
        StoreDataSource(ds, setContext, status) {
            setglobaldata(props.storekey, ds);
            setContext({ rowData: getglobaldata(props.storekey) }, status);
        },
        GetStoreDataSource() {
            try {
                return getglobaldata(props.storekey);
            } catch (e) {
                return [];
            }
        },
        //変更行データ取得
        GetModifyRows() {
            let datasource = [];
            let srcdata = this.GetStoreDataSource();
            let columns = this.GetshownColDef();
            gridApi.forEachNodeAfterFilter(function (node) {
                const result = srcdata.find(e => e.rowid === node.data.rowid)
                if (isEmpty(result)) return;
                let modifyflg = false
                columns.forEach(function (col) {
                    if (result[col.field] !== node.data[col.field]) {
                        modifyflg = true; return;
                    }
                });
                if (modifyflg) datasource.push(node.data);
            });
            return datasource;
        },
        //warning行を除外し変更データをDataSourceに反映
        UpdateModifyRows(warning, setContext) {
            let rows = [];
            //warningがない変更行を抽出
            let target = this.GetModifyRows();
            target.forEach(function (data) {
                let result = warning.find(e => e.rowid === data.rowid);
                if (isEmpty(result))
                    rows.push(data);
            });
            if (rows.length === 0) return;

            let original = this.GetDatasource();
            let srcdata = this.GetStoreDataSource();
            let columns = this.GetshownColDef();
            rows.forEach(function (row) {
                let result = original.find(e => e.rowid === row.rowid);
                let src = srcdata.find(e => e.rowid === row.rowid);
                if (isEmpty(result) || isEmpty(src)) return;

                columns.forEach(function (col) {
                    src[col.field] = result[col.field];
                });
            });

            this.StoreDataSource(srcdata, setContext);
        },
        //指定Rowidの行を選択状態にする
        SetRowSelect(rowid, colId, api) {
            let grid = isEmpty(api) ? gridApi : api;
            grid.deselectAll();
            let node = grid.getRowNode(rowid);
            if (isEmpty(node)) return;
            node.setSelected(true);
            grid.ensureIndexVisible(node.rowIndex, 'top');
            if (!isEmpty(colId)) {
                grid.setFocusedCell(node.rowIndex, colId);
            }
        },
        //非表示の必須項目columnが存在するかチェック
        unshownRequired(columninfo, tabvalue, errfield, slipsave) {
            let column = this.GetshownColDef();
            for (let i = 0; i < columninfo.length; i++) {
                if (tabvalue !== "0" && !columninfo[i].subtable) {
                    if (!isEnabled(slipsave)) continue;     //伝票登録の場合全チェック
                }
                if (!columninfo[i].required) continue;
                if (!columninfo[i].saveed) continue;
                let result = column.find(e => e.field === columninfo[i].columnid);
                if (isEmpty(result)) {
                    errfield.push(columninfo[i].columnnm);
                    return true;
                }
            }
            return false;
        },
        //Primaryが表示されているかチェック
        isshownPrimary(columninfo) {
            let result = columninfo.filter(e => e.primary === true && isEmpty(e.initvalue) && e.required); //主キー&初期値なし&必須
            if (isEmpty(result)) return false;
            let columns = gridApi.getColumnState();
            for (let i = 0; i < result.length; i++) {
                let p = columns.find(e => e.colId === result[i].columnid && !e.hide);
                if (isEmpty(p)) return false;
            }
            return true;
        },
        //選択範囲の列情報を取得
        GetRangeColDef(ranges) {
            let columns = [];
            for (let i = 0; i < ranges[0].columns.length; i++) {
                columns.push(ranges[0].columns[i].colDef);
            }
            return columns;
        },
        //表示columnのColDefを取得
        GetshownColDef(columnapi) {
            let grid = isEmpty(columnapi) ? gridColumnApi : columnapi;
            let all = grid.getAllGridColumns();
            let columns = grid.getColumnState();
            let coldef = [];
            columns.forEach(function (col) {
                if (!col.hide) {
                    let column = all.find(e => e.colId === col.colId);
                    if (!isEmpty(column)) {
                        if (!isEmpty(column.colDef.colinfo)) {
                            coldef.push(
                                {
                                    headerName: column.colDef.headerName,
                                    table: column.colDef.colinfo.table,
                                    field: column.colId,
                                    width: col.width, //column.actualWidth,
                                    pinned: col.pinned ? true : false
                                });
                        }
                    }
                }
            });
            return coldef;
        },
        //表示columnのcolomninfo+ColDefを取得
        GetshownColinfos(columnapi) {
            let grid = isEmpty(columnapi) ? gridApi : columnapi;
            let all = grid.getAllGridColumns();
            let columns = grid.getColumnState();
            let coldef = [];
            columns.forEach(function (col) {
                if (!col.hide) {
                    let column = all.find(e => e.colId === col.colId);
                    if (!isEmpty(column.colDef.colinfo)) {
                        col = { ...col, ...column.colDef };
                        col["pinned"] = col.pinned ? true : false;
                        col["table"] = column.colDef.colinfo.table;
                        coldef.push(col);
                    }
                }
            });
            return coldef;
        },
        //表示columnのColDefをサーバー連携用の型に変換
        GetConvertColDef(gridcoldef, showonly) {
            let coldef = [];
            gridcoldef.forEach(function (col) {
                if (col.field !== "grip") {
                    if (!col.hide || showonly) {
                        coldef.push({ headerName: col.headerName, field: col.field });
                    }
                }
            });
            return coldef;
        },
        //現在のカラム情報を再作成する(並び、表示、幅、固定列の適用)
        GetApplyColumnDefs(columns, columnapi) {
            let grid = isEmpty(columnapi) ? gridApi : columnapi;
            let newcoldefs = [];
            let colState = grid.getColumnState();
            let groupcol = (columns.filter(e => !isEmpty(e.children)).length !== 0)
            if (groupcol) {
                for (let i = 0; i < columns.length; i++) {
                    let state = colState.find(e => e.colId === columns[i].colId);
                    if (!isEmpty(state)) {
                        columns[i].width = state.width;
                        columns[i].hide = state.hide;
                        columns[i].pinned = state.pinned;
                    }
                }
                return columns;
            }
            if (isEmpty(colState)) return newcoldefs;
            for (let i = 0; i < colState.length; i++) {
                let column = columns.find(e => e.colId === colState[i].colId);
                if (!isEmpty(column)) {
                    column.width = colState[i].width;
                    column.hide = colState[i].hide;
                    column.pinned = colState[i].pinned;
                    newcoldefs.push(column);
                }
            }
            return newcoldefs;
        },
        //localstorageから列情報を取得
        LoadColState(id) {
            return Getstorage(corpkey, account, id + "_colstate");
        },
        //列情報をlocalstorageから取得し列定義情報に適用
        GetColState(id, columns) {
            let bakup = DeepCopy(columns)
            let newcolumns = [];
            try {
                const newstate = Getstorage(corpkey, account, id + "_colstate");
                if (isEmpty(newstate)) return columns;
                var state = newstate;
                let grouplist = columns.filter(e => !isEmpty(e.child))
                var childcol = [];
                if (grouplist.length >0) { //children list
                    for (let i = 0; i < grouplist.length; i++) {
                        var childcols = grouplist[i].child;
                        for (let j = 0; j < childcols.length; j++) {
                            childcols[j]["groupcolumn"] = grouplist[i].headerName;
                            childcol.push(childcols[j]);
                        }
                    }
                }

                for (let i = 0; i < state.length; i++) {
                    let column = columns.find(e => e.field === state[i].colId);
                    if (!isEmpty(column)) {
                        if (column.resizable !== false) column.width = state[i].width;
                        column.hide = state[i].hide;
                        column.pinned = state[i].pinned;
                        newcolumns.push(column);
                    } else {
                        if (!grouplist.length > 0) continue;
                        //children listから捜索
                        column = childcol.find(e => e.field === state[i].colId);
                        if (!isEmpty(column)) {
                            if (column.resizable !== false) column.width = state[i].width;
                            column.hide = state[i].hide;
                            column.pinned = state[i].pinned;
                            newcolumns.push(column);
                        }
                    }
                }
                //columnsにあってstateにない項目を追加
                for (let i = 0; i < columns.length; i++) {
                    let column = newcolumns.find(e => e.field === columns[i].field);
                    if (isEmpty(column)) {
                        let addcol = columns[i];
                        addcol.hide = true;
                        newcolumns.push(addcol);
                    }
                }
                if (grouplist.length > 0) {
                    //階層作成
                    let group = "";
                    let child = [];
                    let colDef = [];
                    for (let i = 0; i < newcolumns.length; i++) {
                        if (isEmpty(newcolumns[i].groupcolumn)) {
                            if (child.length !== 0) {
                                let groupcol = {
                                    headerName: group, child: child
                                };
                                colDef.push(groupcol);
                                child = [];
                            }
                            colDef.push(newcolumns[i]);
                        } else {
                            if (group === newcolumns[i].groupcolumn || group === "") {
                                child.push(newcolumns[i]);
                            } else {
                                if (child.length !== 0) {
                                    let groupcol = {
                                        headerName: group, child: child
                                    };
                                    colDef.push(groupcol);
                                }
                                child = [];
                                child.push(newcolumns[i]);
                            }
                        }
                        group = newcolumns[i].groupcolumn;
                    }
                    if (child.length !== 0) {
                        let groupcol = {
                            headerName: group, child: child
                        };
                        colDef.push(groupcol);
                    }
                    newcolumns = colDef;
                }
            } catch { }
            let ret = newcolumns.find(e => e.hide === false && e.field !== 'grip');
            return ret !== undefined ? newcolumns : bakup;
        },
        //列状態をlocalstorageに保存
        SaveColState(id, columnapi) {
            if (columnapi === null) {
                this.RemoveColState(id);
            } else {
                let grid = isEmpty(columnapi) ? gridApi : columnapi;
                if (isEmpty(grid)) return;
                const state = grid.getColumnState();
                Savestorage(corpkey, account, id + "_colstate", state);
            }
        },
        //localstorageの列状態を削除
        RemoveColState(id) {
            Removestorage(corpkey, account, id + "_colstate");
        },
        //行の高さをlocalstorageから取得
        GetRowHeight(id, defaultH) {
            const h = Getstorage(corpkey, account, id + "_rowheight");
            if (isEmpty(h)) return defaultH;
            return h;
        },
        //行の高さをlocalstorageに保存
        SaveRowHeight(id, height) {
            if (height === null) {
                Removestorage(corpkey, account, id + "_rowheight");
            } else {
                Savestorage(corpkey, account, id + "_rowheight", height);
            }
        },
        //有効データが存在するかチェック
        ExistValidRow(rows, columninfo, colState) {
            if (isEmpty(rows)) return false;
            if (isEmpty(colState)) return false;
            if (rows.length === 0) return false;
            for (let r = 0; r < rows.length; r++) {
                let row = rows[r];
                for (let i = 0; i < colState.length; i++) {
                    let key = colState[i];
                    if (key.colId === "rowid") continue;
                    if (!isEmpty(row[key.colId])) {
                        let col = columninfo.find(e => e.columnid === key.colId);
                        if (isEmpty(col)) continue;
                        if (col.datatype !== CELLTYPE.NUM) return true;
                        if (Number(row[key.colId]) !== 0) return true;
                    }
                }
            }
            return false;
        },
        //末尾の無効行を削除
        TrimEndRow(rows, columninfo, colState) {
            if (isEmpty(rows)) return rows;
            if (rows.length === 0) return rows;
            let endidx = rows.length - 1;
            let flag = false;
            for (let r = rows.length-1; r >= 0; r--) {
                let row = rows[r];
                flag = false;
                endidx = r;
                for (let i = 0; i < colState.length; i++) {
                    let key = colState[i];
                    if (key.colId === "rowid") continue;
                    if (!isEmpty(row[key.colId])) {
                        let col = columninfo.find(e => e.columnid === key.colId);
                        if (isEmpty(col)) continue;
                        if (col.datatype !== CELLTYPE.NUM) {
                            flag = true; break;
                        }
                        if (Number(row[key.colId]) !== 0) {
                            flag = true; break;
                        }
                    }
                }
                if (flag) break;
            }
            if (!flag) return [];
            if (rows.length === endidx && flag) return rows;

            return rows.filter((item, index) => index <= endidx);
        },
        //列情報取得
        GetColumnInfo(colId, columninfo) {
            let result = columninfo.find(e => e.columnid === colId);
            return result === undefined ? null : result;
        },
        //TAG列情報取得
        GetTagColumnInfo(columninfo) {
            let result = columninfo.filter(e => e.datatype === CELLTYPE.TAG);
            return result === undefined ? null : result;
        },
        //GridのTAG列からTAGListを取得
        GetTagDataList(colId) {
            return _GetTagDataList(colId);
        },
        //保存された列幅を適用
        LoadColumnWidth(key, columns) {
            columns.forEach(function (col) {
                if (col.hide) return;
                let width = getcookie(key + "_" + col.field);
                if (!isEmpty(width)) col.width = Number(width);
            });
            return columns;
        },
        //列幅の最適化
        AutoSizeColumns(hedderskip, columnapi ) {
            let grid = isEmpty(columnapi) ? gridColumnApi : columnapi;
            var allColumnIds = [];
            grid.getAllGridColumns().forEach(function (column) {
                allColumnIds.push(column.colId);
            });
            grid.autoSizeColumns(allColumnIds, hedderskip);
        },
        //グリッドクリア
        GridClear(rowcount, api, columnapi) {
            let grid = isEmpty(api) ? gridApi : api;
            grid.setGridOption("rowData", this.initialrowData(rowcount, columnapi));
            grid.setGridOption("pinnedBottomRowData",[]);
        },
        //空行データを取得
        initialrowData(rowcount, columnapi) {
            let grid = isEmpty(columnapi) ? gridApi : columnapi;
            let colState = grid.getColumnState();
            let newData = {};
            for (let key in colState) {
                newData[colState[key]['colId']] = "";
            }
            var rows = [];
            for (let i = 0; i < rowcount; i++) {
                let row = Object.assign({}, newData);
                row['rowid'] = RandomKey(gridid);
                rows.push(row);
            }
            return rows;
        },
        //新規行を挿入
        insertRow(rowindex, rowcount, api, columnapi) {
            let newItems = this.initialrowData(rowcount, columnapi);
            let grid = isEmpty(api) ? gridApi : api;
            grid.applyTransaction({ add: newItems, addIndex: rowindex });
        },
        //末尾に新規行を追加
        newRow(rowcount,api, columnapi) {
            let newItems = this.initialrowData(rowcount, columnapi);
            let grid = isEmpty(api) ? gridApi : api;
            let addindex = grid.getDisplayedRowCount();
            grid.applyTransaction({ add: newItems, addIndex: addindex });
        },
        //rowidのrowNodeの次行を取得
        NextrowNode(rowid,api) {
            let grid = isEmpty(api) ? gridApi : api;
            var exist = false;
            var target = null;
            grid.forEachNode(function (node) {
                if (exist) {
                    target = node; exist = false;
                    return;
                }
                if (node.data.rowid === rowid) exist = true;
            });
            return target;
        },
        //ヘッダ定義を作成
        createColDef(all, columns, masterDetail) {
            const colDefsInit = { field: 'rowid', colId: 'rowid', initialHide: true, hide: true, suppressColumnsToolPanel: true, filter: false };
            var colDef = [
                colDefsInit,
                props.total ?
                    {
                        field: 'grip', colId: 'grip', headerName: " ", lockPosition: true, suppressMenu: false,
                        width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true
                    }
                    : {
                        field: 'grip', colId: 'grip', headerName: " ", rowDrag: props.rowDrag !== false, lockPosition: true, suppressMenu: false,
                        width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true
                    }
            ]
            if(isEnabled(masterDetail)) {
                let handle =
                {
                    field: 'expand', colId: 'expand', headerName: " ", lockPosition: true, suppressMenu: false, hide: false,
                    width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true,
                    cellStyle: { 'padding-left': 0 }, menuTabs: ['generalMenuTab']
                }
                colDef.push(handle);
            }
            try {
                for (let i = 0; i < all.length; i++) {
                    let hide = false;
                    let result = columns.filter(e => e.columnid === all[i].columnid);
                    hide = result.length === 0;
                    let column = {
                        headerName: all[i].columnnm,
                        field: all[i].columnid,
                        colId: all[i].columnid,
                        hide: hide,
                        editable: function (params) {
                            if (params.context.entrylock) return false;
                            else return !all[i].locked;
                        },
                        datatype: all[i].datatype,
                        colinfo: all[i],
                        width: 80,
                        menuTabs: ['generalMenuTab']
                    }
                    if (!isEmpty(props.ColdefSpecial)) {
                        props.ColdefSpecial(column);
                    }
                    this.SetColDefTypeInfo(all[i].datatype, column);
                    colDef.push(column);
                }
            } catch (error) {
                console.log(error);
            }
            return colDef;
        },
        //属性に対する列情報設定を追加
        SetColDefTypeInfo(datatype, column) {
            var filterTextParams = {
                filterOptions: [
                    {
                        displayKey: 'contain',
                        displayName: '含む',
                        predicate: ([filterValue], cellValue) => cellValue.indexOf(filterValue) !== -1,
                    },
                    {
                        displayKey: 'notContains',
                        displayName: '含まない',
                        predicate: ([filterValue], cellValue) => cellValue.indexOf(filterValue) === -1,
                    },
                    {
                        displayKey: 'equals',
                        displayName: '同じ',
                        predicate: ([filterValue], cellValue) => cellValue === filterValue,
                    },
                    {
                        displayKey: 'notequals',
                        displayName: '以外',
                        predicate: ([filterValue], cellValue) => cellValue !== filterValue,
                    },
                    {
                        displayKey: 'blank',
                        displayName: '値なし',
                        predicate: (_, cellValue) => isEmpty(cellValue),
                        numberOfInputs: 0,
                    },
                    {
                        displayKey: 'notblank',
                        displayName: '値あり',
                        predicate: (_, cellValue) => !isEmpty(cellValue),
                        numberOfInputs: 0,
                    }
                ],
            };
            switch (datatype) {
                case CELLTYPE.TEXTAREA:
                    column['wrapText'] = true;
                    column['filter'] = "agTextColumnFilter";
                    column['filterParams'] = filterTextParams;
                     break;
                case CELLTYPE.NUM:
                    column['filter'] = "agNumberColumnFilter";
                    column['filterParams'] = {
                        filterOptions: [
                            {
                                displayKey: 'equals',
                                displayName: '＝　等しい',
                                predicate: ([filterValue], cellValue) => Number(cellValue) === Number(filterValue),
                            },
                            {
                                displayKey: 'notequals',
                                displayName: '≠　等しくない',
                                predicate: ([filterValue], cellValue) => NumConv(cellValue) !== filterValue,
                            },
                            {
                                displayKey: 'lessthaneq',
                                displayName: '≦　以下',
                                predicate: ([filterValue], cellValue) => cellValue == null || cellValue <= filterValue,
                            },
                            {
                                displayKey: 'greaterThaneq',
                                displayName: '≧　以上',
                                predicate: ([filterValue], cellValue) => cellValue >= filterValue,
                            },
                            {
                                displayKey: 'betweenExclusive',
                                displayName: '範囲',
                                predicate: ([fv1, fv2], cellValue) => fv1 <= cellValue && fv2 >= cellValue,
                                numberOfInputs: 2,
                            },
                            {
                                displayKey: 'blank',
                                displayName: '値なし',
                                predicate: (_, cellValue) => NumConv(cellValue) === 0,
                                numberOfInputs: 0,
                            },
                            {
                                displayKey: 'notblank',
                                displayName: '値あり',
                                predicate: (_, cellValue) => NumConv(cellValue) !== 0,
                                numberOfInputs: 0,
                            }
                        ]
                    };
                    column['cellClass'] = 'ag-right-aligned-cell';
                    column['comparator'] = numberSort
                    break;
                case CELLTYPE.DATE:
                    column['filter'] = "agDateColumnFilter";
                    column['filterParams'] = {
                        filterOptions: [
                            {
                                displayKey: 'equals',
                                displayName: '＝　等しい',
                                predicate: ([filterValue], cellValue) => {
                                    return cellValue === toStringDate(filterValue);
                                },
                            },
                            {
                                displayKey: 'notequals',
                                displayName: '≠　等しくない',
                                predicate: ([filterValue], cellValue) => {
                                    return cellValue !== toStringDate(filterValue);
                                }
                            },
                            {
                                displayKey: 'lessthaneq',
                                displayName: '≦　以下',
                                predicate: ([filterValue], cellValue) => isEmpty(cellValue) || cellValue <= toStringDate(filterValue),
                            },
                            {
                                displayKey: 'greaterThaneq',
                                displayName: '≧　以上',
                                predicate: ([filterValue], cellValue) => cellValue >= toStringDate(filterValue),
                            },
                            {
                                displayKey: 'betweenExclusive',
                                displayName: '範囲',
                                predicate: ([fv1, fv2], cellValue) => toStringDate(fv1) <= cellValue && toStringDate(fv2) >= cellValue,
                                numberOfInputs: 2,
                            },
                            {
                                displayKey: 'blank',
                                displayName: '値なし',
                                predicate: (_, cellValue) => isEmpty(cellValue),
                                numberOfInputs: 0,
                            },
                            {
                                displayKey: 'notblank',
                                displayName: '値あり',
                                predicate: (_, cellValue) => !isEmpty(cellValue),
                                numberOfInputs: 0,
                            }
                        ]
                    };
                    break;
                case CELLTYPE.TAG:
                    column['filter'] = "agSetColumnFilter";
                    column['keyCreator'] = TagKeyCreator;
                    break;
                case CELLTYPE.STICKY:
                    column['valueGetter'] = stickeygetter;
                    column['valueSetter'] = stickeysetter;
                    column['filter'] = "agMultiColumnFilter";
                    column['filterParams'] = stickyFilterParams;
                    setglobaldata(props.stickykey, column.field);   //Sticky Filter用
                    break;
                case CELLTYPE.TEXT:
                case CELLTYPE.MASTERREF:
                    column['filter'] = "agTextColumnFilter";
                    column['filterParams'] = filterTextParams;
                    break;
                case CELLTYPE.SELECT:
                case CELLTYPE.CHECK:
                    column['filter'] = "agSetColumnFilter";
                    break;
                case "storagesticky":
                    column['valueGetter'] = stickeygetter;
                    column['valueSetter'] = stickeysetter;
                    column['filter'] = "agMultiColumnFilter";
                    column['filterParams'] = strstickyFilterParams;
                    break;
                default:
                    column['filter'] = "agSetColumnFilter";
                    //column['filter'] = "agMultiColumnFilter";
                    break;
            }
        },
        //固定列設定 type:0=left 1=right
        SetPining(type) {
            var Columns = [];
            var all = gridColumnApi.getAllGridColumns();
            var pinned = type === 0 ? gridColumnApi.isPinningLeft() : gridColumnApi.isPinningRight();
            if (!pinned) {
                if (type === 0) {
                    for (let i = 0; i < all.length; i++) {
                        if (all[i].visible) {
                            Columns.push({ colId: all[i].colId, pinned: 'left' });
                            break;
                        }
                    }
                    for (let i = 0; i < all.length; i++) {
                        if (all[i].pinned === 'right') {
                            Columns.push({ colId: all[i].colId, pinned: all[i].pinned });
                        }
                    }
                } else {
                    for (let i = 0; i < all.length; i++) {
                        if (all[i].pinned === 'left') {
                            Columns.push({ colId: all[i].colId, pinned: all[i].pinned });
                        }
                    }
                    for (let i = all.length - 1; i >= 0; i--) {
                        if (all[i].visible) {
                            Columns.push({ colId: all[i].colId, pinned: 'right' });
                            break;
                        }
                    }
                }
            } else {
                for (let i = 0; i < all.length; i++) {
                    if (all[i].pinned === (type === 0 ? 'left' : 'right')) {
                        Columns.push({ colId: all[i].colId, pinned: null });
                    } else {
                        Columns.push({ colId: all[i].colId, pinned: all[i].pinned });
                    }
                }
            }
            if (Columns.length !== 0) {
                gridApi.applyColumnState({
                    state: Columns,
                    defaultState: { pinned: null },
                });
            }
        },
        //固定列取得 type:0=left 1=right
        GetPin(colstate, type) {
            let colid = [];
            var pinned = type === 0 ? gridColumnApi.isPinningLeft() : gridColumnApi.isPinningRight();
            if (!pinned) return colid;

            if (type === 0) {
                for (let i = 0; i < colstate.length; i++) {
                    if (colid.length !== 0 && colstate[i].pinned === null)
                        break;
                    if (colstate[i].pinned === 'left')
                        colid.push(colstate[i].colId);
                }
            } else {
                for (let i = colstate.length - 1; i <= 0; i++) {
                    if (colid.length !== 0 && colstate[i].pinned === null)
                        break;
                    if (colstate[i].pinned === 'right') {
                        colid.push(colstate[i].colId);
                        break;
                    }
                }
            }
            return colid;
        },
    }));

    function _GetTagDataList(colId) {
        let group = "";
        let tag = [];
        //colId列より重複をはじいたデータリストを取得
        gridApi.forEachNode(function (node) {
            if (!isEmpty(DicVal(node.data, colId, "")))
                tag.push(node.data[colId]);
        });
        tag = [...new Set(tag)];    //重複除去
        //データリストより文字列を分解し重複をはじいたTAGリストを作成
        let taglist = [];
        tag.forEach(function (list) {
            const tags = replaceall(list, "　", " ").split(' ');
            for (let i = 0; i < tags.length; i++) {
                taglist.push({ code: tags[i], kind:group });
            }
        });
        taglist = removeDuplicates(taglist);    //重複除去
        return taglist;
    }

    const numberSort = (num1, num2) => {
        return num1 - num2;
    };
    const TagKeyCreator = function (params) {
        if (!params.value) return '';
        return params.value.trim().toLowerCase();
    };
    const dateFilterParams = {
        comparator: function (filterLocalDateAtMidnight, cellValue) {
            var dateAsString = cellValue;
            if (dateAsString == null) return -1;
            var dateParts = dateAsString.split('/');
            var cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
        },
        browserDatePicker: true,
    };
    const stickeygetter = function (params) {
        if (isEmpty(params.data)) return '';
        if (params.colDef.colId in params.data) {
            var data = params.data[params.colDef.colId];
            if (typeof data !== 'object') return '';
            if ('note' in data) return data.note;
            else return '';
        } else return '';
    };
    const stickeysetter = function (params) {
        if (typeof params.newValue === 'object') {
            if (params.colDef.colId in params.data) {
                if (typeof params.data[params.colDef.colId] === 'object') {
                    params.data[params.colDef.colId].mark = params.newValue.mark;
                    params.data[params.colDef.colId].color = params.newValue.color;
                    return true;
                }
            }
            params.data[params.colDef.colId] = { mark: params.newValue.mark, color: params.newValue.color };
        } else {
            if (params.colDef.colId in params.data) {
                if (typeof params.data[params.colDef.colId] === 'object') {
                    params.data[params.colDef.colId].note = params.newValue;
                    return true;
                }
            }
            params.data[params.colDef.colId] = { note: params.newValue };
        }
        return true;
    };

    const stickeyColorvalueGetter = function (params) {
        let key = getglobaldata(props.stickykey);
        let data = params.data[key];
        return stickycolor(data);
    }
    const stickeyMarkvalueGetter = function (params) {
        let key = getglobaldata(props.stickykey);
        let data = params.data[key];
        return stickymark(data);
    }
   const stickyFilterParams = {
        filters: [
            {
                filter: 'agTextColumnFilter',
            },
            {
                filter: 'agSetColumnFilter',
                filterParams: {
                    valueGetter: stickeyColorvalueGetter,
                    defaultToNothingSelected: true,
                    suppressMiniFilter: true,
                },
            },
            {
                filter: 'agSetColumnFilter',
                filterParams: {
                    valueGetter: stickeyMarkvalueGetter,
                    defaultToNothingSelected: true,
                    suppressMiniFilter: true,
                },
            },
        ],
    };
    const strstickeyColorvalueGetter = function (params) {
        let data = params.data["sticky"];
        return stickycolor(data);
    }
    const strstickeyMarkvalueGetter = function (params) {
        let data = params.data["sticky"];
        return stickymark(data);
    }
    const strstickyFilterParams = {
        filters: [
            {
                filter: 'agTextColumnFilter',
            },
            {
                filter: 'agSetColumnFilter',
                filterParams: {
                    valueGetter: strstickeyColorvalueGetter,
                    defaultToNothingSelected: true,
                    suppressMiniFilter: true,
                },
            },
            {
                filter: 'agSetColumnFilter',
                filterParams: {
                    valueGetter: strstickeyMarkvalueGetter,
                    defaultToNothingSelected: true,
                    suppressMiniFilter: true,
                },
            },
        ],
    };

    //必要
    return null;
};

